import {connect} from 'react-redux';
import {CACHE as LOADING_CACHE} from '../../components/common/loading';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import DynamicDestinationRefinementsComponent from './DynamicDestinationRefinements';

const mapStateToProps = (state) => {
    const {
        config: {
            template,
            url: {basePathPrefix},
            context: {isBot},
            site,
            isRefined,
        },
        destination: {
            details: {lbsId, seoPath},
        },
        options: {destinationRefinementsMode, useSlpCanonical},
        hasTouch,
    } = state;

    return {
        basePathPrefix,
        lbsId,
        seoPath,
        site,
        isRefined,
        useSlpCanonical,
        template,
        isBot,
        mode: destinationRefinementsMode,
        hasTouch,
    };
};

const DynamicDestinationRefinements = connect(mapStateToProps)(
    determineIfMobile(DynamicDestinationRefinementsComponent)
);

DynamicDestinationRefinements.displayName = 'DynamicDestinationRefinements';

LOADING_CACHE.set(DynamicDestinationRefinements, {
    componentType: 'DynamicDestinationRefinements',
    placeholderType: 'Carousel',
});

export default DynamicDestinationRefinements;
